import React from "react";
import { ShieldCheck, GraduationCap, School } from "lucide-react";

const ChildCard = ({ student, onAuthenticate }) => {
  const { name, imageUrl, grade, school, isAuthSetup } = student;

  // Generate initials for avatar placeholder
  const getInitials = (fullName) => {
    if (!fullName) return "?";
    return fullName
      .split(" ")
      .slice(0, 2)
      .map((n) => n[0])
      .join("")
      .toUpperCase();
  };

  return (
    <div className="bg-white border border-slate-200/80 rounded-2xl p-3.5 w-full max-w-sm shadow-sm hover:shadow-md hover:border-slate-350 transition-all duration-300 flex flex-col justify-between min-h-[170px]">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={name}
              className="w-12 h-12 rounded-xl object-cover border border-slate-100 shadow-3xs"
            />
          ) : (
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 text-white flex items-center justify-center text-base font-bold shadow-3xs">
              {getInitials(name)}
            </div>
          )}
        </div>
        <div className="space-y-0.5 min-w-0 flex-1">
          <h4 className="text-base font-black text-slate-800 capitalize leading-tight truncate">
             {name}
          </h4>
          <div className="flex items-center gap-1.5 text-slate-500 text-xs font-semibold">
            <GraduationCap className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" />
            <span>{grade ? (grade.toLowerCase().startsWith("class") ? grade : `Class ${grade}`) : "N/A"}</span>
          </div>
          <div className="flex items-center gap-1.5 text-slate-400 text-xs font-medium">
            <School className="w-3.5 h-3.5 text-slate-350 flex-shrink-0" />
            <span className="truncate">{school || "No School Added"}</span>
          </div>
        </div>
      </div>

      <div className="pt-3 space-y-2">
        {isAuthSetup ? (
          <div className="flex items-center justify-center gap-1.5 text-[11px] text-emerald-700 bg-emerald-50 border border-emerald-100/60 px-3 py-1.5 rounded-xl font-black">
            <ShieldCheck className="w-4 h-4 text-emerald-600 flex-shrink-0" />
            <span>Profile Verified & Linked</span>
          </div>
        ) : (
          <>
            {/* Warning Alert Banner */}
            <div className="flex items-center gap-1.5 text-[10px] text-red-650 bg-red-50 border border-red-100/60 px-2 py-1 rounded-lg font-bold">
              <span className="relative flex h-1.5 w-1.5 flex-shrink-0">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-red-500"></span>
              </span>
              <span>Profile Unverified: Authentication Required</span>
            </div>

            {/* Urgent Action Button */}
            <button
              type="button"
              className="w-full py-1.5 px-3 bg-gradient-to-r from-red-500 to-red-700 hover:from-red-600 hover:to-red-800 text-white rounded-xl text-xs font-black shadow-3xs hover:shadow-2xs transition-all duration-200 flex items-center justify-center gap-1.5 group"
              onClick={() => onAuthenticate && onAuthenticate(student)}
            >
              <ShieldCheck className="w-4 h-4 text-white/95 group-hover:scale-110 transition-transform" />
              Authenticate Now
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ChildCard;
